import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home/index.vue'
import quickStartRouter from './file-center/quick-start'
import basicAbilityRouter from './file-center/basic-ability'
import cloudAbilityRouter from './file-center/cloudfile-ability'
import enterpriseAbilityRouter from './file-center/enterprise-ability'
import wwoAbilityRouter from './file-center/wwo-ability'
import enterpriseInnerApp from './file-center/enterprise-inner-app'
import downloadResourceRouter from './file-center/download-resource'
import { EDeveloperStatus } from '@/apps/open/store/modules/user/types'
import docConversionRouter from './file-center/doc-conversion'
import docAIOpen from './file-center/doc-ai'
import privateDocMenu from '../views/fileCenter/PrivateDocMenu.json'
import priMiddleDocMenu from '../views/fileCenter/PriMiddleDocMenu.json'
import PriGeneralDocMenu from '../views/fileCenter/PriGeneralDocMenu.json'
const isPrivate: boolean = process.env.VUE_APP_IS_PRIVATE
const isGeneralPrivate: boolean = isPrivate && window.$$DEPLOY_OPENDOC === 'none'
const isPriDocMiddle: boolean = window.$$DEPLOY_YUNDOC === 'false'
const pathValue: string = isPrivate ? location.pathname : '/'
const priDocRouter: any = {}
let curRouterItem: any = {}

interface DocRouter {
  path: string
  name: string
  meta?: object,
  redirect?: string,
  component?: Function
  children?: DocRouter[]
}

function appendRouter (ctn: any, routerInfo: any, isDocRouter: boolean) {
  const routeItem: any = {
    path: routerInfo.path,
    meta: routerInfo.meta,
    component: () => import(`@/apps/open/views/fileCenter/components/${isDocRouter ? 'FileContent.vue' : 'FileRouter.vue'}`)
  }
  if (routerInfo.router_name) routeItem.name = routerInfo.router_name
  if (routerInfo.redirect) routeItem.redirect = routerInfo.redirect
  ctn && ctn.push(routeItem)
}

function setChildrenRouter (container: any, childrens: DocRouter[]) {
  if (childrens && childrens.length > 0) {
    childrens.forEach((curRouterItem: any, idx: number) => {
      if (curRouterItem.children && curRouterItem.children.length > 0) {
        appendRouter(container, curRouterItem, false)
        if (!container[idx].children) container[idx].children = []
        return setChildrenRouter(container[idx].children, curRouterItem.children)
      } else {
        appendRouter(container, curRouterItem, true)
      }
    })
  }
}

function setDocRouter (menuJson: any) {
  Object.keys(menuJson).forEach((key) => {
    curRouterItem = menuJson[key]
    if (curRouterItem && curRouterItem.length > 0) {
      if (!priDocRouter[key]) priDocRouter[key] = []
      setChildrenRouter(priDocRouter[key], curRouterItem)
    }
  })
}
// to get document menu in private environment
isPrivate && (isPriDocMiddle ? setDocRouter(priMiddleDocMenu) : isGeneralPrivate ? setDocRouter(PriGeneralDocMenu) : setDocRouter(privateDocMenu))

Vue.use(Router)

const allStatus = [ EDeveloperStatus.PASSED, EDeveloperStatus.PENDING, EDeveloperStatus.REJECTED ]
const passedStatus = [ EDeveloperStatus.PASSED ]
const rejectedStatus = [ EDeveloperStatus.REJECTED ]

export default new Router({
  mode: isPrivate ? 'hash' : 'history',
  base: pathValue,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/case-detail',
      name: 'case-detail',
      component: () => import(/* webpackChunkName: "case-detail" */ '../views/caseDetail/index.vue')
    },
    {
      path: '/app-center',
      name: 'app-center',
      component: () => import('../views/AppCenter.vue')
    },
    {
      path: '/app-access',
      name: 'app-access',
      component: () => import('../views/appAccess/index.vue')
    },
    {
      path: '/docs/',
      name: 'doc',
      redirect: isPrivate ? isPriDocMiddle ? '/docs/middle-app/appmgr/access-know' : '/docs/enterprise-inner-app' : '/docs/cloud/case-solution',
      component: () => import('../views/fileCenter/index.vue'),
      children: [
        {
          path: 'office',
          name: 'doc.office',
          meta: { title: 'WPS客户端二次开发' },
          component: () => import(/* webpackChunkName: "doc-office" */ '../views/fileCenter/Office.vue')
        },
        {
          path: 'cloud',
          name: 'doc.cloud',
          redirect: '/docs/cloud/case-solution',
          meta: { title: '金山文档', path: '/docs/cloud/case-solution', mdfilepath: '/quickstart/PlatformOverview.md', aimtilelist: ['概述', '开发者接入流程', '提供的能力'] },
          component: () => import(/* webpackChunkName: "doc-cloud" */ '../views/fileCenter/Cloud.vue'),
          children: isPrivate ? priDocRouter.kdocs : [
            ...quickStartRouter,
            basicAbilityRouter,
            cloudAbilityRouter,
            enterpriseAbilityRouter,
            downloadResourceRouter
          ]
        },
        {
          path: 'enterprise-inner-app',
          name: 'doc.enterprise-inner-app',
          redirect: isPrivate ? '/docs/enterprise-inner-app/app-config' : '/docs/enterprise-inner-app/admin-config',
          component: () => import(/* webpackChunkName: "doc-enterprise-inner-app" */ '../views/fileCenter/EnterpriseInnerApp.vue'),
          meta: { title: '企业内部应用' },
          children: isPrivate ? priDocRouter.enterprise_inner_app : [
            ...enterpriseInnerApp
          ]
        },
        {
          path: 'middle-app',
          name: 'doc.middle-app',
          redirect: '/docs/middle-app/appmgr/access-know',
          component: () => import(/* webpackChunkName: "doc-enterprise-inner-app" */ '../views/fileCenter/EnterpriseInnerApp.vue'),
          meta: { title: '文档中台应用' },
          children: priDocRouter.doc_middle_app
        },
        {
          path: 'wwo',
          name: 'doc.wwo',
          redirect: '/docs/wwo/access-know',
          component: () => import(/* webpackChunkName: "doc-wwo" */ '../views/fileCenter/Wwo.vue'),
          meta: { title: '文档在线预览编辑' },
          children: isPrivate ? priDocRouter.doc_online_edit : [
            wwoAbilityRouter
          ]
        },
        {
          path: 'doc-format-conversion',
          name: 'doc.doc-format-conversion',
          component: () => import(/* webpackChunkName: "doc-format-conversion" */ '../views/fileCenter/DocFormatConversion.vue'),
          meta: { title: '文档格式转换' },
          redirect: '/docs/doc-format-conversion/access-know',
          children: isPrivate ? priDocRouter.doc_format_conversion : [
            ...docConversionRouter
          ]
        },
        {
          path: 'doc-ai-open',
          name: 'doc.doc-ai-open',
          component: () => import(/* webpackChunkName: "doc-ai-open" */ '../views/fileCenter/AI.vue'),
          meta: { title: 'WPS AI开放能力' },
          redirect: '/docs/doc-ai-open/access-know',
          children: [
            ...docAIOpen
          ]
        }]
    },
    {
      path: '',
      component: () => import('../views/devCenter/index.vue'),
      meta: { requireAuth: true },
      children: [
        {
          path: '/developer-info',
          name: 'developer-info',
          component: () => import(/* webpackChunkName: "developer-info" */ '../views/devCenter/DeveloperInfo.vue'),
          redirect: '/developer-info/kdoc-apps',
          children: [
            {
              path: 'kdoc-apps',
              name: 'kdoc-apps',
              component: () => import(/* webpackChunkName: "kdoc-apps" */ '../views/devCenter/kdocApps.vue')
            },
            {
              path: 'online-edit-service',
              name: 'online-edit-service',
              component: () => import(/* webpackChunkName: "online-edit-service" */ '../views/devCenter/onlineEdit.vue')
            },
            {
              path: 'conversion-apps',
              name: 'doc-conversion-apps',
              component: () => import(/* webpackChunkName: "doc-conversion-apps" */ '../views/devCenter/docConversion/Apps.vue')
            },
            {
              path: 'ai-apps',
              name: 'ai-apps',
              component: () => import(/* webpackChunkName: "doc-conversion-apps" */ '../views/devCenter/ai/Apps.vue')
            }
          ]
        },
        {
          path: '/add-app/:id?',
          name: 'add-app',
          component: () => import(/* webpackChunkName: "add-app" */ '../views/devCenter/AddApp.vue')
        },
        {
          path: '/app-info/:id',
          component: () => import(/* webpackChunkName: "app-info" */ '../views/devCenter/myApp/Index.vue'),
          children: [
            {
              path: 'setting',
              name: 'app-setting',
              component: () => import(/* webpackChunkName: "app-setting" */ '../views/devCenter/myApp/Setting/Index.vue')
            },
            {
              path: 'permission',
              name: 'app-permission',
              component: () => import(/* webpackChunkName: "app-permission" */ '../views/devCenter/myApp/Permission.vue')
            },
            {
              path: 'member',
              name: 'app-member',
              component: () => import(/* webpackChunkName: "app-member" */ '../views/devCenter/myApp/Member.vue')
            },
            {
              path: 'order',
              name: 'app-order',
              component: () => import(/* webpackChunkName: "app-vas" */ '../views/devCenter/myApp/Order.vue')
            },
            {
              path: 'info',
              name: 'app-info',
              component: () => import('@/apps/open/views/devCenter/myApp/Info.vue')
            },
            {
              path: 'callback-config',
              name: 'callback-config',
              component: () => import('@/apps/open/views/devCenter/myApp/Callback.vue')
            },
            {
              path: 'msg-callback-config',
              name: 'msg-callback-config',
              component: () => import('@/apps/open/views/devCenter/myApp/MsgCallback.vue')
            },
            {
              path: 'doc-edit-callback-config',
              name: 'doc-edit-callback-config',
              component: () => import('@/apps/open/views/devCenter/myApp/DocEditCallback.vue')
            },
            {
              path: 'doc-preview-callback-config',
              name: 'doc-preview-callback-config',
              component: () => import('@/apps/open/views/devCenter/myApp/DocPreviewCallback.vue')
            },
            {
              path: 'doc-format-callback-config',
              name: 'doc-format-callback-config',
              component: () => import('@/apps/open/views/devCenter/myApp/DocFormatCallback.vue')
            },
            {
              path: 'certificate-callback',
              name: 'certificate-callback',
              component: () => import('@/apps/open/views/devCenter/myApp/CertificateCallback.vue')
            },
            {
              path: 'auth',
              name: 'app-auth',
              component: () => import('@/apps/open/views/devCenter/myApp/Auth.vue')
            },
            {
              path: 'sync',
              name: 'app-sync',
              component: () => import('@/apps/open/views/devCenter/myApp/Sync.vue')
            },
            {
              path: 'space-config',
              name: 'space-config',
              component: () => import('@/apps/open/views/devCenter/myApp/SpaceManage.vue')
            }
          ]
        },
        {
          path: '/admin-users',
          name: 'admin-users',
          meta: { requireDeveloperStatus: passedStatus },
          component: () => import('../views/devCenter/adminUser/Index.vue')
        },
        {
          path: '/weboffice',
          component: () => import('../views/devCenter/weboffice/Index.vue'),
          meta: { requireDeveloperStatus: passedStatus },
          children: [
            {
              path: '/',
              name: 'weboffice-list',
              component: () => import('../views/devCenter/weboffice/List.vue')
            },
            {
              path: ':id',
              name: 'weboffice-info',
              component: () => import('../views/devCenter/weboffice/Info.vue')
            }
          ]
        },
        {
          path: '/format-conversion/:id',
          name: 'conversion-admin',
          component: () => import('../views/devCenter/docConversion/Admin.vue'),
          meta: { requireDeveloperStatus: passedStatus }
        },
        {
          path: '/ai-admin/:app_name',
          name: 'ai-admin',
          component: () => import('../views/devCenter/ai/Admin.vue'),
          meta: { requireDeveloperStatus: passedStatus }
        }
      ]
    },
    {
      path: '/apply-developer',
      name: 'apply-developer',
      meta: { requireAuth: true },
      component: () => import(/* webpackChunkName: "apply-developer" */ '../views/ApplyDeveloper.vue')
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "agreement" */ '../views/Agreement.vue')
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],
  scrollBehavior: function (to, from) {
    if (to.path.indexOf('/docs') < 0 || from.path.indexOf('/docs') < 0) {
      return { x: 0, y: 0 }
    }
  }
})
